module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"variant_images":"Variant images","delete_images_confirmation":"Are you sure you want to delete these images? These images will be deleted permanently."},"id":{"variant_images":"Gambar Varian","delete_images_confirmation":"Anda yakin ingin menghapus gambar ini? Gambar-gambar ini akan dihapus secara permanen."}}')
  delete Component.options._Ctor
}
